import { AuditInfo } from './audit-info.model';

export class UserMDRef {
    id: number;
    username: string;
    firstName: string;
    lastName: string;
}

export class MedicalCenter {
    id: number;
    code: string;
    descr: string;
    indirizzo: string;
    luogo: string;
    provincia: string;
    users: UserMDRef[];
    auditInfo: AuditInfo;
    patientsCount?: number;

    hasUser(username: string) {
        return !!this.users.find(item => item.username === username);
    }
}
